import { getPath } from '@/router/common'

const baseUrl = {
  title: '核销',
  path: 'cCWriteOffDetailed'
}

export default [
  {
    path: getPath('index', baseUrl),
    name: 'cCWriteOffDetailed_index',
    component: () => import(/* webpackChunkName: "cCWriteOffDetailed_index" */ '@/views/cCWriteOffDetailed/index/index.vue'),
    meta: {
      title: '核销明细'
    }
  },
  {
    path: getPath('CCWriteOffAdd', baseUrl),
    name: 'CCWriteOffAdd',
    component: () => import(/* webpackChunkName: "CCWriteOffAdd" */ '@/views/cCWriteOffDetailed/cCWriteOffAdd/index.vue'),
    meta: {
      title: '结款核销'
    }
  },
  {
    path: getPath('CCNewDetail', baseUrl),
    name: 'CCWriteOffDetailed_CCNewDetail',
    component: () => import(/* webpackChunkName: "CCWriteOffDetailed_CCNewDetail" */ '@/views/cCWriteOffDetailed/cCNewDetail/index.vue'),
    meta: {
      title: '查看业务明细'
    }
  },
]
